import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Themes',
    href: '#themes'
  }, {
    name: 'Packages',
    href: '#packages'
  }, {
    name: 'Our Story',
    href: '#about'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 bg-white border-b border-soft-terracotta/10 ${isScrolled ? 'shadow-sm py-4' : 'py-5'}`} data-id="element-82" data-mp="31e1qny6hq8wy">
      
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-83" data-mp="3bbzgur7wufs7">
        <a href="#" className="group flex items-center" aria-label="Wishing Tree Events home" data-id="element-84" data-mp="3fc9kvyc56w4f">
          
          <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/ntvlqtkffhdbb8r9fejcsv/998f55ba-f676-4af8-a27d-47f6f60444b4/Asset_44x.png" alt="Wishing Tree Events" className="h-9 md:h-11 w-auto object-contain transition-transform group-hover:scale-[1.02]" data-id="element-85" data-mp="2wm5rqy80yyzi" />
          
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10 font-normal" data-id="element-86" data-mp="3fbcaumcqdslu">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-soft-dark hover:text-soft-terracotta transition-colors text-sm tracking-wide" data-id="element-87" data-mp="3ac95f0su9kdc">
            
              {link.name}
            </a>)}
          <motion.a whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} href="#contact" className="bg-soft-terracotta text-white px-7 py-2.5 rounded-full shadow-sm hover-bg-soft-terracotta transition-all font-medium text-sm tracking-wide" data-id="element-88" data-mp="30mfve48chdb7">
            
            Book a Party
          </motion.a>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden text-soft-terracotta p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-89" data-mp="1rfnzlhqwk5c5">
          
          {mobileMenuOpen ? <X className="w-6 h-6 stroke-[1.5]" data-id="element-90" data-mp="1hojlslcyqqiw" /> : <Menu className="w-6 h-6 stroke-[1.5]" data-id="element-91" data-mp="1hni1rrdyytp1" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-warm-ivory border-t border-soft-terracotta/10 shadow-xl py-6 px-6 flex flex-col gap-6" data-id="element-92" data-mp="18n3ckgxvwug9">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-base font-normal text-soft-dark hover:text-soft-terracotta transition-colors tracking-wide" data-id="element-93" data-mp="1cmkhn99efpkw">
          
              {link.name}
            </a>)}
          <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="bg-soft-terracotta text-white px-6 py-3 text-center mt-2 rounded-full font-medium shadow-sm active:scale-95 transition-all text-sm tracking-wide" data-id="element-94" data-mp="2t2nhbvz78mq2">
          
            Book a Party
          </a>
        </div>}
    </header>;
}